import { makeAutoObservable, reaction } from 'mobx';
import { toast } from 'react-toastify';
import { ServerError } from '../models/serverError';
import { historyPayloadType } from '../models/history';
import { store } from './store';

interface LanguageI {
  value: string;
  key: string;
  flag: string;
  text: string;
}

export default class CommonStore {
  language: LanguageI = {
    key: 'En',
    text: 'English',
    flag: 'us',
    value: 'English',
  };
  isCountUpdated = false;
  error: ServerError | null = null;
  token: string | null = window.localStorage.getItem('jwt');
  appLoaded = false;
  filterModeZero: string[] = [];
  filterModeOne: string[] = [];
  filterModeTwo: string[] = [];
  staticDemoChanges: boolean = false;
  chartRoleInfo: any[] = [];
  staticRegisterDemoChanges: boolean = false;
  markLoginStaticRegisterDemoChages: boolean = false;
  hfcCustomerChanges: boolean = false;
  markLoginStaticChangesForCard: boolean = false;
  devEnv: boolean = false;
  isLoginFirstTimeHomepage: boolean = false;
  newPassword: string | null = window.localStorage.getItem('jwt');
  defaultPassword: string | null = window.localStorage.getItem('jwt');
  restorationDefectDetails:any[]=[];
  RestorationCustomer:boolean = false;
  NFAIReportCustomer:boolean =  false;
  NFAIodsModel:boolean = false;
  static language: any;
  constructor() {
    makeAutoObservable(this);

    reaction(
      () => this.token,
      (token) => {
        if (token) {
          window.localStorage.setItem('jwt', token);
        } else {
          window.localStorage.removeItem('jwt');
        }
      },
    );
  }

  setServerError = (error: ServerError) => {
    this.error = error;
  };

  setToken = (token: string | null) => {
    this.token = token;
  };
  setNewPassword = (newPassword: string | null) => {
    this.newPassword = newPassword;
  };
  setDefaultPassword = (defaultPassword: string | null) => {
    this.defaultPassword = defaultPassword;
  };
  setAppLoaded = () => {
    this.appLoaded = true;
  };
  userReadableDateFormat = (date: any) => {
    // const getTime=date&& new Date(date+"Z").toLocaleTimeString();
    const getTime = date?.split('T')?.[1];
    const getDate = date && date?.slice(0, 10)?.split('-'); //create an array
    const _date =
      getDate?.length > 1 && getDate !== undefined
        ? getDate[2] + '-' + getDate[1] + '-' + getDate[0] + 'T' + getTime
        : ''; //setting the date time
    return _date;
  };
  userReadableDateFormatMessage = (date: any) => {
    const getTime = date && date.split('T')[1];
    const getDate = date && date?.slice(0, 10)?.split('-'); //create an array
    const _date =
      getDate?.length > 1 && getDate !== undefined
        ? getDate[2] + '-' + getDate[1] + '-' + getDate[0] + 'T' + getTime
        : ''; //setting the date time
    return _date;
  };
  userReadableDateFormatMetaData = (date: string) => {
    const getTime = date && new Date(date + 'Z').toLocaleTimeString();
    const getDate = date && date?.slice(0, 10)?.split('/'); //create an array
    const _date =
      getDate?.length > 1 && getDate !== undefined
        ? getDate[1] + '-' + getDate[0] + '-' + getDate[2] + 'T' + getTime
        : ''; //setting the date time
    return _date;
  };

  genericValidation = (value: string, type: string) => {
    switch (type) {
      case 'Alpha':
        return value
          ? /^[a-zA-Z\s]+$/g.test(value)
            ? ''
            : 'Alpha letters only'
          : '';
      case 'Numeric':
        return value
          ? /^[\d\s]+$/g.test(value)
            ? ''
            : 'Numeric letters only'
          : '';
      case 'Alpha Numeric':
        return value
          ? /^[\w\s]+$/g.test(value)
            ? ''
            : 'Alpha & Numeric letters only'
          : '';
      case 'Email':
        return value
          ? /* eslint-disable-next-line */
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/g.test(value)
            ? ''
            : 'Entered an invalid email'
          : '';
      case 'AlphaMandatory':
        return value
          ? /^[a-zA-Z\s]+$/g.test(value)
            ? ''
            : 'Alpha letters only'
          : 'This is mandory field';
      case 'NumericMandatory':
        return value
          ? /^[\d\s]+$/g.test(value)
            ? ''
            : 'Numeric letters only'
          : 'This is mandory field';
      case 'AlphaNumericMandatory':
        return value
          ? /^[\w\s]+$/g.test(value)
            ? ''
            : 'Alpha & Numeric letters only'
          : 'This is mandory field';
      default:
        return '';
    }
  };

  userRedableDateRegister = (date: string) => {
    const getDate = date.split('-'); //create an array
    const _date = getDate[2] + '-' + getDate[1] + '-' + getDate[0];
    return _date;
  };

  updateHistoryAlonePOST = async (
    status: string,
    id: string,
    completeHandler?: (id: string) => void,
    showToast: boolean = true,
    noRefresh?:boolean,
  ) => {
    try {
      const payload: historyPayloadType = {
        taskId: '',
        taskName: '',
        subTaskId: '',
        subTaskName: '',
        status: status,
        date: new Date(),
      };
      // updateHistoryMain(payload, !showToast, true, noRefresh || false);
      await store.viewStore.addHistory(
        { itemId: id },
        payload,
        !showToast || false,
        noRefresh || false,
      );
      // const hisData = {
      //   id: uuid(),
      //   appUserId:
      //     store.userStore.user?.id !== undefined ? store.userStore.user.id : '',
      //   username:
      //     store.userStore.user?.displayName !== undefined
      //       ? store.userStore.user.displayName
      //       : '',
      //   dateTime: new Date().toISOString(),
      //   status: status,
      // };
      // const HistoryArr: any = {
      //   id,
      //   itemHistory: [hisData],
      // };
      // await agent.Activities.onlyHistory(id, HistoryArr);
      // showToast && toast.success('History updated successfully.');
    } catch {
      toast.error('History is not updated.');
    } finally {
      completeHandler?.(id);
    }
  };

  updateDateTime = () => {
    const today: any = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1;

    const yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    const time = new Date().toLocaleTimeString();
    return dd + '/' + mm + '/' + yyyy + ' ' + time;
  };

  ChartInfosetRoleId = (data: any) => {
    this.chartRoleInfo.push(...data);
  };
  DemoChangesforApprovedCard = () => {
    this.markLoginStaticChangesForCard = false;
  };
}
